// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"_da-z"};